import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/zujian/home'
import shouye from '@/components/comment/shouye'
import login from '@/components/comment/login'
Vue.use(Router)


export default new Router({
    mode: 'history',
    // base: '/yyadmin/',
    routes: [{
            path: '/',
            name: 'shouye',
            component: shouye,
            meta: {
                title: '首页',
            },
            children: [
                // [资讯]
                {
                    path: '/newsLists',
                    component: () =>
                        import ('../components/page/cdy/newsLists'),
                    meta: {
                        title: '资讯列表',
                    }
                },
                {
                    path: '/newsKinds',
                    name: 'newsKinds',
                    component: resolve => (require(["@/components/page/cdy/newsKinds"], resolve)),
                    meta: {
                        title: '资讯分类',
                    }
                },
                {
                    path: '/newsAdd',
                    name: 'newsAdd',
                    component: resolve => (require(["@/components/page/cdy/newsAdd"], resolve)),
                    meta: {
                        title: '添加资讯',
                    }
                },
                {
                    path: '/newsEdit',
                    name: 'newsEdit',
                    component: resolve => (require(["@/components/page/cdy/newsEdit"], resolve)),
                    meta: {
                        title: '编辑资讯',
                    }
                },
                {
                    path: '/newsComment',
                    name: 'newsComment',
                    component: resolve => (require(["@/components/page/cdy/newsComment"], resolve)),
                    meta: {
                        title: '评价管理',
                    }
                },
                {
                    path: '/messageLists',
                    name: 'messageLists',
                    component: resolve => (require(["@/components/page/message/messageLists"], resolve)),
                    meta: {
                        title: '消息列表',
                    }
                },
                {
                    path: '/messageSiteLists',
                    name: 'messageSiteLists',
                    component: resolve => (require(["@/components/page/message/messageSiteLists"], resolve)),
                    meta: {
                        title: '资讯消息设置',
                    }
                },
                {
                    path: '/manageLists',
                    name: 'manageLists',
                    component: resolve => (require(["@/components/page/moveManage/manageLists"], resolve)),
                    meta: {
                        title: '动态管理列表',
                    }
                },
                {
                    path: '/manageAdd',
                    name: 'manageAdd',
                    component: resolve => (require(["@/components/page/moveManage/manageAdd"], resolve)),
                    meta: {
                        title: '动态管理添加',
                    }
                },
                {
                    path: '/manageEdit',
                    name: 'manageEdit',
                    component: resolve => (require(["@/components/page/moveManage/manageEdit"], resolve)),
                    meta: {
                        title: '动态管理编辑',
                    }
                },
                // [订单]
                {
                    path: '/orderRecord',
                    name: 'orderRecord',
                    component: resolve => (require(["@/components/page/orderManage/orderRecord"], resolve)),
                    meta: {
                        title: '订单记录',
                    },
                },
                {
                    path: '/orderRecords',
                    name: 'orderRecords',
                    component: resolve => (require(["@/components/page/orderManage/orderRecords"], resolve)),
                    meta: {
                        title: '订单记录',
                    },
                },
                {
                    path: '/vipOrder',
                    name: 'vipOrder',
                    component: resolve => (require(["@/components/page/orderManage/vipOrder"], resolve)),
                    meta: {
                        title: '会员订单',
                    }
                },
                {
                    path: '/daiBuyOrder',
                    name: 'daiBuyOrder',
                    component: resolve => (require(["@/components/page/orderManage/daiBuyOrder"], resolve)),
                    meta: {
                        title: '代买订单',
                    }
                },
                // [用户管理]
                {
                    path: '/userLists',
                    name: 'userLists',
                    component: resolve => (require(["@/components/page/userManage/userLists"], resolve)),
                    meta: {
                        title: '用户列表',
                    }
                },
                {
                    path: '/userDetail',
                    name: 'userDetail',
                    component: resolve => (require(["@/components/page/userManage/userDetail"], resolve)),
                    meta: {
                        title: '用户详情信息',
                    }
                },
                {
                    path: '/userTransfer',
                    name: 'userTransfer',
                    component: resolve => (require(["@/components/page/userManage/userTransfer"], resolve)),
                    meta: {
                        title: '用户转移',
                    }
                },
                {
                    path: '/vipUserLists',
                    name: 'vipUserLists',
                    component: resolve => (require(["@/components/page/userManage/vipUserManage/vipUserLists"], resolve)),
                    meta: {
                        title: '会员列表',
                    }
                },
                {
                    path: '/vipReadeemCode',
                    name: 'vipReadeemCode',
                    component: resolve => (require(["@/components/page/userManage/vipUserManage/vipReadeemCode"], resolve)),
                    meta: {
                        title: '会员兑换码',
                    }
                },
                {
                    path: '/siteVipLists',
                    name: 'siteVipLists',
                    component: resolve => (require(["@/components/page/userManage/vipUserManage/siteVipLists"], resolve)),
                    meta: {
                        title: '会员权益设置',
                    }
                },
                {
                    path: '/creatVip',
                    name: 'creatVip',
                    component: resolve => (require(["@/components/page/userManage/vipUserManage/creatVip"], resolve)),
                    meta: {
                        title: '会员创建',
                    }
                },
                {
                    path: '/siteVipEdit',
                    name: 'siteVipEdit',
                    component: resolve => (require(["@/components/page/userManage/vipUserManage/siteVipEdit"], resolve)),
                    meta: {
                        title: '会员列表编辑',
                    }
                },
                {
                    path: '/teacherLists',
                    name: 'teacherLists',
                    component: resolve => (require(["@/components/page/userManage/teacherManage/teacherLists"], resolve)),
                    meta: {
                        title: '教师管理',
                    }
                },
                {
                    path: '/editTeacher',
                    name: 'editTeacher',
                    component: resolve => (require(["@/components/page/userManage/teacherManage/editTeacher"], resolve)),
                    meta: {
                        title: '编辑教师',
                    }
                },
                {
                    path: '/addTeacher',
                    name: 'addTeacher',
                    component: resolve => (require(["@/components/page/userManage/teacherManage/addTeacher"], resolve)),
                    meta: {
                        title: '添加教师',
                    }
                },
                {
                    path: '/userLoginRecord',
                    name: 'userLoginRecord',
                    component: resolve => (require(["@/components/page/userManage/userLoginRecord"], resolve)),
                    meta: {
                        title: '用户登录记录',
                    }
                },
                // [分销]
                {
                    path: '/distributionRecord',
                    name: 'distributionRecord',
                    component: resolve => (require(["@/components/page/distributionManage/distributionRecord"], resolve)),
                    meta: {
                        title: '分销记录',
                    }
                },
                {
                    path: '/failRecord',
                    name: 'failRecord',
                    component: resolve => (require(["@/components/page/distributionManage/failRecord"], resolve)),
                    meta: {
                        title: '分销失败记录',
                    }
                },
                {
                    path: '/userIdentity',
                    name: 'userIdentity',
                    component: resolve => (require(["@/components/page/distributionManage/twoLevel/userIdentity"], resolve)),
                    meta: {
                        title: '用户身份',
                    }
                },
                {
                    path: '/addpicture',
                    name: 'addpicture',
                    component: resolve => (require(["@/components/page/distributionManage/addpicture"], resolve)),
                    meta: {
                        title: '添加分销图',
                    }
                },
                {
                    path: '/addIdentity',
                    name: 'addIdentity',
                    component: resolve => (require(["@/components/page/distributionManage/twoLevel/addIdentity"], resolve)),
                    meta: {
                        title: '添加用户身份',
                    }
                },
                {
                    path: '/editIdentity',
                    name: 'editIdentity',
                    component: resolve => (require(["@/components/page/distributionManage/twoLevel/editIdentity"], resolve)),
                    meta: {
                        title: '编辑用户身份',
                    }
                },
                {
                    path: '/threeAdd',
                    name: 'threeAdd',
                    component: resolve => (require(["@/components/page/distributionManage/threeLevel/threeAdd"], resolve)),
                    meta: {
                        title: '三级添加',
                    }
                },
                {
                    path: '/threeEdit',
                    name: 'threeEdit',
                    component: resolve => (require(["@/components/page/distributionManage/threeLevel/threeEdit"], resolve)),
                    meta: {
                        title: '三级编辑',
                    }
                },

                {
                    path: '/distributionSite',
                    name: 'distributionSite',
                    component: resolve => (require(["@/components/page/distributionManage/distributionSite"], resolve)),
                    meta: {
                        title: '分销设置',
                    }
                },
                {
                    path: '/recommendImg',
                    name: 'recommendImg',
                    component: resolve => (require(["@/components/page/distributionManage/recommendImg"], resolve)),
                    meta: {
                        title: '推荐注册图',
                    }
                },
                {
                    path: '/classImg',
                    name: 'classImg',
                    component: resolve => (require(["@/components/page/distributionManage/classImg"], resolve)),
                    meta: {
                        title: '课程分销图',
                    }
                },
                // [财务管理]
                {
                    path: '/orderRecordMoney',
                    name: 'orderRecordMoney',
                    component: resolve => (require(["@/components/page/financialManage/orderRecordMoney"], resolve)),
                    meta: {
                        title: '订单记录',
                    }
                },
                {
                    path: '/refundLists',
                    name: 'refundLists',
                    component: resolve => (require(["@/components/page/financialManage/refundLists"], resolve)),
                    meta: {
                        title: '退款列表',
                    }
                },
                {
                    path: '/vipOrderMoney',
                    name: 'vipOrderMoney',
                    component: resolve => (require(["@/components/page/financialManage/vipOrderMoney"], resolve)),
                    meta: {
                        title: '会员订单',
                    }
                },
                {
                    path: '/fenRecord',
                    name: 'fenRecord',
                    component: resolve => (require(["@/components/page/financialManage/fenRecord"], resolve)),
                    meta: {
                        title: '分销记录',
                    }
                },
                {
                    path: '/fenFailRecord',
                    name: 'fenFailRecord',
                    component: resolve => (require(["@/components/page/financialManage/fenFailRecord"], resolve)),
                    meta: {
                        title: '分销失败记录',
                    }
                },
                {
                    path: '/assetsmanger',
                    name: 'assetsmanger',
                    component: resolve => (require(["@/components/page/financialManage/assetsmanger"], resolve)),
                    meta: {
                        title: '资产管理',
                    }
                },
                {
                    path: '/tixianpage',
                    name: 'tixianpage',
                    component: resolve => (require(["@/components/page/financialManage/tixianpage"], resolve)),
                    meta: {
                        title: '提现管理',
                    }
                },
                // [提现管理]
                {
                    path: '/withdrawLists',
                    name: 'withdrawLists',
                    component: resolve => (require(["@/components/page/withdraw/withdrawLists"], resolve)),
                    meta: {
                        title: '提现记录',
                    }
                },
                {
                    path: '/withdrawPei',
                    name: 'withdrawPei',
                    component: resolve => (require(["@/components/page/withdraw/withdrawPei"], resolve)),
                    meta: {
                        title: '提现配置',
                    }
                },
                // [分销里提现配置]
                {
                    path: '/withdrawFen',
                    name: 'withdrawFen',
                    component: resolve => (require(["@/components/page/withdraw/withdrawFen"], resolve)),
                    meta: {
                        title: '提现记录',
                    }
                },
                {
                    path: '/withdrawFenPei',
                    name: 'withdrawFenPei',
                    component: resolve => (require(["@/components/page/withdraw/withdrawFenPei"], resolve)),
                    meta: {
                        title: '提现配置',
                    }
                },





                // [活动---》课程买赠]
                {
                    path: '/buyMessage',
                    name: 'buyMessage',
                    component: resolve => (require(["@/components/page/activityCDY/classBuy/buyMessage"], resolve)),
                    meta: {
                        title: '买赠列表',
                    }
                },
                {
                    path: '/addClass1',
                    name: 'addClass1',
                    component: resolve => (require(["@/components/page/activityCDY/classBuy/addClass1"], resolve)),
                    meta: {
                        title: '添加线上课程',
                    }
                },
                {
                    path: '/editClass',
                    name: 'editClass',
                    component: resolve => (require(["@/components/page/activityCDY/classBuy/editClass"], resolve)),
                    meta: {
                        title: '编辑线上课程',
                    }
                },
                {
                    path: '/pointManage',
                    name: 'pointManage',
                    component: resolve => (require(["@/components/page/activityCDY/point/pointManage"], resolve)),
                    meta: {
                        title: '积分管理',
                    }
                },
                {
                    path: '/openImgLists',
                    name: 'openImgLists',
                    component: resolve => (require(["@/components/page/activityCDY/openImg/openImgLists"], resolve)),
                    meta: {
                        title: '开屏图',
                    }
                },
                {
                    path: '/addOpenImg',
                    name: 'addOpenImg',
                    component: resolve => (require(["@/components/page/activityCDY/openImg/addOpenImg"], resolve)),
                    meta: {
                        title: '添加开屏图',
                    }
                },
                {
                    path: '/editOpenImg',
                    name: 'editOpenImg',
                    component: resolve => (require(["@/components/page/activityCDY/openImg/editOpenImg"], resolve)),
                    meta: {
                        title: '编辑开屏图',
                    }
                },



                // [数据分析]
                {
                    path: '/userAnalysis',
                    name: 'userAnalysis',
                    component: resolve => (require(["@/components/page/dataAnalysis/userAnalysis"], resolve)),
                    meta: {
                        title: '用户数据分析',
                    }
                },
                {
                    path: '/foodAnalysis',
                    name: 'foodAnalysis',
                    component: resolve => (require(["@/components/page/dataAnalysis/foodAnalysis"], resolve)),
                    meta: {
                        title: '商品分析',
                    }
                },
                {
                    path: '/liveGai',
                    name: 'liveGai',
                    component: resolve => (require(["@/components/page/dataAnalysis/liveGai"], resolve)),
                    meta: {
                        title: '直播概况',
                    }
                },
                {
                    path: '/flowOrder',
                    name: 'flowOrder',
                    component: resolve => (require(["@/components/page/dataAnalysis/flowOrder"], resolve)),
                    meta: {
                        title: '流量订购',
                    }
                },
                {
                    path: '/livemaindesc',
                    name: 'livemaindesc',
                    component: resolve => (require(["@/components/page/dataAnalysis/livemaindesc"], resolve)),
                    meta: {
                        title: '直播概况',
                    }
                },

                // [我的订购]
                {
                    path: '/bookLists',
                    name: 'bookLists',
                    component: resolve => (require(["@/components/page/book/bookLists"], resolve)),
                    meta: {
                        title: '服务订购',
                    }
                },
                {
                    path: '/flowBook',
                    name: 'flowBook',
                    component: resolve => (require(["@/components/page/book/flowBook"], resolve)),
                    meta: {
                        title: '订购续费',
                    }
                },
                {
                    path: '/orderingflow',
                    name: 'orderingflow',
                    component: resolve => (require(["@/components/page/book/orderingflow"], resolve)),
                    meta: {
                        title: '服务订购',
                    }
                },
                {
                    path: '/flowRecord',
                    name: 'flowRecord',
                    component: resolve => (require(["@/components/page/book/flowRecord"], resolve)),
                    meta: {
                        title: '购买记录',
                    }
                },
                {
                    path: '/messagetip',
                    name: 'messagetip',
                    component: resolve => (require(["@/components/page/book/messagetip"], resolve)),
                    meta: {
                        title: '短信使用说明',
                    }
                },






















                {
                    path: '/baselist',
                    name: 'baselist',
                    component: resolve => (require(["@/components/course/baselist"], resolve))
                },

                // 直播聊天室
                {
                    path: '/zbochat',
                    name: 'zbochat',
                    component: resolve => (require(["@/components/course/zbochat"], resolve))
                },
                // 用户自定义信息
                {
                    path: '/userinforindex',
                    name: 'userinforindex',
                    component: resolve => (require(["@/components/other/userinfor/userinforindex"], resolve)),
                },
                // app更新
                {
                    path: '/updataindex',
                    name: 'updataindex',
                    component: resolve => (require(["@/components/updataApp/updataindex"], resolve)),
                },
                {
                    path: '/addupdata',
                    name: 'addupdata',
                    component: resolve => (require(["@/components/updataApp/addupdata"], resolve)),
                },

                // 课程管理
                {
                    path: '/courseposter',
                    name: 'courseposter',
                    component: resolve => (require(["@/components/course/courseposter"], resolve)),
                },
                {
                    path: '/worklist',
                    name: 'worklist',
                    component: resolve => (require(["@/components/course/homework/worklist"], resolve)),
                },
                {
                    path: '/allpaper',
                    name: 'allpaper',
                    component: resolve => (require(["@/components/course/homework/allpaper"], resolve)),
                },
                {
                    path: '/courseDemant',
                    name: 'courseDemant',
                    component: resolve => (require(["@/components/course/courseDemant"], resolve)),
                    meta: {
                        title: '视频课',
                    }
                },
                {
                    path: '/addcourse',
                    name: 'addcourse',
                    component: resolve => (require(["@/components/course/addcourse"], resolve)),
                    meta: {
                        title: '添加',
                    }
                },
                {
                    path: '/courseset',
                    name: 'courseset',
                    component: resolve => (require(["@/components/course/courseset"], resolve)),
                    meta: {
                        title: '课程设置',
                    }
                },
                {
                    path: '/coursezbo',
                    name: 'coursezbo',
                    component: resolve => (require(["@/components/course/coursezbo"], resolve)),
                    meta: {
                        title: '直播课',
                    }
                },
                {
                    path: '/class',
                    name: 'class',
                    component: resolve => (require(["@/components/course/class"], resolve)),
                    meta: {
                        title: '大专栏',
                    }
                },
                {
                    path: '/moreaddvideo',
                    name: 'moreaddvideo',
                    component: resolve => (require(["@/components/course/assistant/specadd/moreaddvideo"], resolve)),
                },
                {
                    path: '/special',
                    name: 'special',
                    component: resolve => (require(["@/components/course/special"], resolve)),
                    meta: {
                        title: '专栏',
                    }
                },
                {
                    path: '/offlinecourse',
                    name: 'offlinecourse',
                    component: resolve => (require(["@/components/course/offlinecourse"], resolve)),
                    meta: {
                        title: '线下课',
                    }
                },
                {
                    path: '/zbohistion',
                    name: 'zbohistion',
                    component: resolve => (require(["@/components/course/zbohistion"], resolve)),
                    meta: {
                        title: '直播历史',
                    }
                },
                {
                    path: '/addspec',
                    name: 'addspec',
                    component: resolve => (require(["@/components/course/addspec"], resolve)),
                    meta: {
                        title: '添加',
                    }
                },
                {
                    path: '/addclass',
                    name: 'addclass',
                    component: resolve => (require(["@/components/course/addclass"], resolve)),
                    meta: {
                        title: '添加',
                    }
                },
                {
                    path: '/categoryadmin',
                    name: 'categoryadmin',
                    component: resolve => (require(["@/components/course/courseset/categoryadmin"], resolve)),
                    meta: {
                        title: '分类管理',
                    }
                },
                {
                    path: '/courseinexset',
                    name: 'courseinexset',
                    component: resolve => (require(["@/components/course/courseset/courseinexset"], resolve)),
                    meta: {
                        title: '课程信息导出设置',
                    }
                },
                {
                    path: '/zboadmin',
                    name: 'zboadmin',
                    component: resolve => (require(["@/components/course/courseset/zboadmin"], resolve)),
                    meta: {
                        title: '直播管理',
                    }
                },
                {
                    path: '/demandadmin',
                    name: 'demandadmin',
                    component: resolve => (require(["@/components/course/courseset/demandadmin"], resolve)),
                    meta: {
                        title: '回放管理',
                    }
                },
                {
                    path: '/freeusertype',
                    name: 'freeusertype',
                    component: resolve => (require(["@/components/course/courseset/freeusertype"], resolve)),
                    meta: {
                        title: '免费用户类型',
                    }
                },
                {
                    path: '/moreoper',
                    name: 'moreoper',
                    component: resolve => (require(["@/components/course/moreoper"], resolve)),
                    meta: {
                        title: '更多操作',
                    }
                },
                {
                    path: '/specconadmin',
                    name: 'specconadmin',
                    component: resolve => (require(["@/components/course/assistant/specconadmin"], resolve)),
                    meta: {
                        title: '内容管理',
                    }
                },
                {
                    path: '/specaddvideo',
                    name: 'specaddvideo',
                    component: resolve => (require(["@/components/course/assistant/specadd/specaddvideo"], resolve)),
                    meta: {
                        title: '内容管理',
                    }
                },
                {
                    path: '/bigclasscourse',
                    name: 'bigclasscourse',
                    component: resolve => (require(["@/components/course/assistant/specadd/bigclasscourse"], resolve)),
                    meta: {
                        title: '内容管理',
                    }
                },
                {
                    path: '/classconadmin',
                    name: 'classconadmin',
                    component: resolve => (require(["@/components/course/assistant/classconadmin"], resolve)),
                    meta: {
                        title: '内容管理',
                    }
                },
                {
                    path: '/rewardindex',
                    name: 'rewardindex',
                    component: resolve => (require(["@/components/course/reward/rewardindex"], resolve)),
                    meta: {
                        title: '内容管理',
                    }
                },
                {
                    path: '/mobile',
                    name: 'mobile',
                    component: resolve => (require(["@/components/shop/mobile"], resolve)),
                    meta: {
                        title: '移动端',
                    }
                },
                {
                    path: '/setup',
                    name: 'setup',
                    component: resolve => (require(["@/components/shop/setup"], resolve)),
                    meta: {
                        title: '店铺设置',
                    }
                },
                {
                    path: '/configuration',
                    name: 'configuration',
                    component: resolve => (require(["@/components/shop/setmain/configuration"], resolve)),
                    meta: {
                        title: '公众号配置',
                    }
                },
                {
                    path: '/configurationeid',
                    name: 'configurationeid',
                    component: resolve => (require(["@/components/shop/setmain/configurationeid"], resolve)),
                    meta: {
                        title: '公众号配置',
                    }
                },
                {
                    path: '/overview',
                    name: 'overview',
                    component: resolve => (require(["@/components/shop/overview"], resolve)),
                    meta: {
                        title: '店铺概览',
                    }
                },
                {
                    path: '/share',
                    name: 'share',
                    component: resolve => (require(["@/components/shop/share"], resolve)),
                    meta: {
                        title: '分享语设置',
                    }
                },
                {
                    path: '/shareset',
                    name: 'shareset',
                    component: resolve => (require(["@/components/shop/setmain/shareset"], resolve)),
                    meta: {
                        title: '分享语添加',
                    }
                },
                {
                    path: '/adminadd',
                    name: 'adminadd',
                    component: resolve => (require(["@/components/shop/setmain/adminadd"], resolve)),
                    meta: {
                        title: '管理员添加',
                    }
                },
                {
                    path: '/role',
                    name: 'role',
                    component: resolve => (require(["@/components/shop/role"], resolve)),
                    meta: {
                        title: '权限管理',
                    }
                },
                {
                    path: '/computer',
                    name: 'computer',
                    component: resolve => (require(["@/components/shop/computer"], resolve)),
                    meta: {
                        title: '电脑端',
                    }
                },
                {
                    path: '/appupdate',
                    name: 'appupdate',
                    component: resolve => (require(["@/components/shop/appupdate"], resolve)),
                    meta: {
                        title: '',
                    }
                },
                {
                    path: '/uniappinfo',
                    name: 'uniappinfo',
                    component: resolve => (require(["@/components/shop/uniappinfo"], resolve)),
                    meta: {
                        title: '',
                    }
                },
                {
                    path: '/coupon',
                    name: 'coupon',
                    component: resolve => (require(["@/components/activity/coupon/coupon"], resolve)),
                    meta: {
                        title: '优惠券',
                    }
                },
                {
                    path: '/addcoupon',
                    name: 'addcoupon',
                    component: resolve => (require(["@/components/activity/coupon/addcoupon"], resolve)),
                    meta: {
                        title: '添加优惠券',
                    }
                },
                {
                    path: '/addcouponcart',
                    name: 'addcouponcart',
                    component: resolve => (require(["@/components/activity/coupon/addcouponcart"], resolve)),
                    meta: {
                        title: '优惠券',
                    }
                },
                {
                    path: '/couponcart',
                    name: 'couponcart',
                    component: resolve => (require(["@/components/activity/coupon/couponcart"], resolve)),
                    meta: {
                        title: '优惠券',
                    }
                },
                {
                    path: '/sendcartlist',
                    name: 'sendcartlist',
                    component: resolve => (require(["@/components/activity/coupon/sendcartlist"], resolve)),
                    meta: {
                        title: '添加优惠券',
                    }
                },
                {
                    path: '/discount',
                    name: 'discount',
                    component: resolve => (require(["@/components/activity/discount/discount"], resolve)),
                    meta: {
                        title: '促销打折',
                    }
                },
                {
                    path: '/adddiscount',
                    name: 'adddiscount',
                    component: resolve => (require(["@/components/activity/discount/adddiscount"], resolve)),
                    meta: {
                        title: '添加促销打折',
                    }
                },
                {
                    path: '/bragaining',
                    name: 'bragaining',
                    component: resolve => (require(["@/components/activity/bargainingt/bragaining"], resolve)),
                    meta: {
                        title: '砍价',
                    }
                },
                {
                    path: '/addbragain',
                    name: 'addbragain',
                    component: resolve => (require(["@/components/activity/bargainingt/addbragain"], resolve)),
                    meta: {
                        title: '添加砍价',
                    }
                },
                {
                    path: '/savetuition',
                    name: 'savetuition',
                    component: resolve => (require(["@/components/activity/Savetuition/savetuition"], resolve)),
                    meta: {
                        title: '攒学费',
                    }
                },
                {
                    path: '/addsavetution',
                    name: 'addsavetution',
                    component: resolve => (require(["@/components/activity/Savetuition/addsavetution"], resolve)),
                    meta: {
                        title: '攒学费',
                    }
                },
                {
                    path: '/opinion',
                    name: 'opinion',
                    component: resolve => (require(["@/components/shop/opinion"], resolve)),
                    meta: {
                        title: '意见反馈',
                    }
                },
                {
                    path: '/commentmanger',
                    name: 'commentmanger',
                    component: resolve => (require(["@/components/shop/commentmanger"], resolve)),
                    meta: {
                        title: '评论管理',
                    }
                },

                {
                    path: '/evaluate',
                    name: 'evaluate',
                    component: resolve => (require(["@/components/shop/evaluate"], resolve)),
                    meta: {
                        title: '全局搜索',
                    }
                },

                // 活动
                {
                    path: '/addscreen',
                    name: 'addscreen',
                    component: resolve => (require(["@/components/activity/openscreen/addscreen"], resolve)),
                    meta: {
                        title: '添加启屏图',
                    }
                },
                {
                    path: '/screenlist',
                    name: 'screenlist',
                    component: resolve => (require(["@/components/activity/openscreen/screenlist"], resolve)),
                    meta: {
                        title: '启屏图',
                    }
                },
                {
                    path: '/addAssistance',
                    name: 'addAssistance',
                    component: resolve => (require(["@/components/activity/Assistance/addAssistance"], resolve)),
                    meta: {
                        title: '添加助力活动',
                    }
                },
                {
                    path: '/Assistancelist',
                    name: 'Assistancelist',
                    component: resolve => (require(["@/components/activity/Assistance/Assistancelist"], resolve)),
                    meta: {
                        title: '助力活动',
                    }
                },
                {
                    path: '/Assistanceorder',
                    name: 'Assistanceorder',
                    component: resolve => (require(["@/components/activity/Assistance/Assistanceorder"], resolve)),
                    meta: {
                        title: '助力',
                    }
                },
                {
                    path: '/addgroup',
                    name: 'addgroup',
                    component: resolve => (require(["@/components/activity/group/addgroup"], resolve)),
                    meta: {
                        title: '添加助力活动',
                    }
                },
                {
                    path: '/grouplist',
                    name: 'grouplist',
                    component: resolve => (require(["@/components/activity/group/grouplist"], resolve)),
                    meta: {
                        title: '助力活动',
                    }
                },
                {
                    path: '/grouporder',
                    name: 'grouporder',
                    component: resolve => (require(["@/components/activity/group/grouporder"], resolve)),
                    meta: {
                        title: '助力',
                    }
                },

                // 视频素材
                {
                    path: '/videolist',
                    name: 'videolist',
                    component: resolve => (require(["@/components/course/materialCenter/videolist"], resolve)),
                },
                {
                    path: '/recycle',
                    name: 'recycle',
                    component: resolve => (require(["@/components/course/materialCenter/recycle"], resolve)),
                },
                {
                    path: '/recycleimg',
                    name: 'recycleimg',
                    component: resolve => (require(["@/components/course/materialCenter/recycleimg"], resolve)),
                },
                {
                    path: '/addtail',
                    name: 'addtail',
                    component: resolve => (require(["@/components/course/materialCenter/addtail"], resolve)),
                },
                // myaccountnew
                {
                    path: '/myaccountnew',
                    name: 'myaccountnew',
                    component: resolve => (require(["@/components/newcontent/myaccountnew"], resolve)),
                },
                {
                    path: '/contentmainew',
                    name: 'contentmainew',
                    component: resolve => (require(["@/components/newcontent/contentmainew"], resolve)),
                },

                //内容模块
                {
                    path: '/contentmain',
                    name: 'contentmain',
                    component: resolve => (require(["@/components/content/contentmain"], resolve)),
                },
                {
                    path: '/ondemand',
                    name: 'ondemand',
                    component: resolve => (require(["@/components/page/dataAnalysis/ondemand"], resolve)),
                    meta: {
                        title: '概况',
                    }
                },
                //视频课详情
                {
                    path: '/videodesc',
                    name: 'videodesc',
                    component: resolve => (require(["@/components/content/videodesc"], resolve)),
                },
                //我分销的商品
                {
                    path: '/mykehumain',
                    name: 'mykehumain',
                    component: resolve => (require(["@/components/content/mykehumain"], resolve)),
                },
                //内容方配置
                {
                    path: '/otherpeople',
                    name: 'otherpeople',
                    component: resolve => (require(["@/components/content/otherpeople"], resolve)),
                },
                {
                    path: '/coursebianji',
                    name: 'coursebianji',
                    component: resolve => (require(["@/components/content/coursebianji"], resolve)),
                },
                {
                    path: '/managementgroup',
                    name: 'managementgroup',
                    component: resolve => (require(["@/components/content/managementgroup"], resolve)),
                },
                {
                    path: '/librarybooks',
                    name: 'librarybooks',
                    component: resolve => (require(["@/components/content/librarybooks"], resolve)),
                },
                {
                    path: '/offlinecoursebook',
                    name: 'offlinecoursebook',
                    component: resolve => (require(["@/components/content/offlinecoursebook"], resolve)),
                },
                {
                    path: '/addpricedown',
                    name: 'addpricedown',
                    component: resolve => (require(["@/components/content/addpricedown"], resolve)),
                },
                {
                    path: '/alldescifo',
                    name: 'alldescifo',
                    component: resolve => (require(["@/components/content/alldescifo"], resolve)),
                },
                {
                    path: '/schoolist',
                    name: 'schoolist',
                    component: resolve => (require(["@/components/content/schoolist"], resolve)),
                },
                {
                    path: '/changeorder',
                    name: 'changeorder',
                    component: resolve => (require(["@/components/content/changeorder"], resolve)),
                }, {
                    path: '/pushstudent',
                    name: 'pushstudent',
                    component: resolve => (require(["@/components/content/pushstudent"], resolve)),
                },
                {
                    path: '/bookinfo',
                    name: 'bookinfo',
                    component: resolve => (require(["@/components/content/bookinfo"], resolve)),
                },
                {
                    path: '/myaccount',
                    name: 'myaccount',
                    component: resolve => (require(["@/components/content/myaccount"], resolve)),
                },
                {
                    path: '/myshoppingcart',
                    name: 'myshoppingcart',
                    component: resolve => (require(["@/components/content/myshoppingcart"], resolve)),
                },
                {
                    path: '/orderinfodesc',
                    name: 'orderinfodesc',
                    component: resolve => (require(["@/components/content/orderinfodesc"], resolve)),
                },
                {
                    path: '/ediishenqing',
                    name: 'ediishenqing',
                    component: resolve => (require(["@/components/content/ediishenqing"], resolve)),
                },
                {
                    path: '/xianqingunder',
                    name: 'xianqingunder',
                    component: resolve => (require(["@/components/content/xianqingunder"], resolve)),
                },

                {
                    path: '/agentlist',
                    name: 'agentlist',
                    component: resolve => (require(["@/components/agent/agentlist"], resolve)),
                },
                {
                    path: '/addagent',
                    name: 'addagent',
                    component: resolve => (require(["@/components/agent/addagent"], resolve)),
                },
                {
                    path: '/agentincome',
                    name: 'agentincome',
                    component: resolve => (require(["@/components/agent/agentincome"], resolve)),
                },
                {
                    path: '/agentcashout',
                    name: 'agentcashout',
                    component: resolve => (require(["@/components/agent/agentcashout"], resolve)),
                },
                {
                    path: '/agentdistribution',
                    name: 'agentdistribution',
                    component: resolve => (require(["@/components/agent/agentdistribution"], resolve)),
                },
                {
                    path: '/generalagent',
                    name: 'generalagent',
                    component: resolve => (require(["@/components/agent/generalagent"], resolve)),
                },
                {
                    path: '/importcoursemain',
                    name: 'importcoursemain',
                    component: resolve => (require(["@/components/agent/general/importcoursemain"], resolve)),
                },
                {
                    path: '/changegeneral',
                    name: 'changegeneral',
                    component: resolve => (require(["@/components/agent/general/changegeneral"], resolve)),
                },  
                {  
                    path:   '/agentdistributionfen',
                    name:   'agentdistributionfen',
                    component:  resolve  =>  (require(["@/components/agent/agentdistributionfen"],  resolve)),
                },
                {                    
                    path:   '/addagentfen',
                    name:   'addagentfen',
                    component:  resolve  =>  (require(["@/components/agent/addagentfen"],  resolve)),
                },
                {                    
                    path:   '/schoolmanag',
                    name:   'schoolmanag',
                    component:  resolve  =>  (require(["@/components/agent/schoolmanag"],  resolve)),
                },
                {                    
                    path:   '/threeAddtoo',
                    name:   'threeAddtoo',
                    component:  resolve  =>  (require(["@/components/agent/threeAddtoo"],  resolve)),
                },

                {
                    path: '/questionbank',
                    name: 'questionbank',
                    component: resolve => (require(["@/components/questionbank/questionbank"], resolve)),
                },
                {
                    path: '/tikushare',
                    name: 'tikushare',
                    component: resolve => (require(["@/components/questionbank/tikushare"], resolve)),
                },
                //商城
                {
                    path: '/shopping',
                    name: 'shopping',
                    component: resolve => (require(["@/components/shoppingpage/shopping"], resolve)),
                },
                {
                    path: '/shoppinglist',
                    name: 'shoppinglist',
                    component: resolve => (require(["@/components/market/shoppinglist"], resolve)),
                }, {
                    path: '/addgood',
                    name: 'addgood',
                    component: resolve => (require(["@/components/market/addgood"], resolve)),
                },
                {
                    path: '/shoppingorder',
                    name: 'shoppingorder',
                    component: resolve => (require(["@/components/market/shoppingorder"], resolve)),
                },
                {
                    path: '/shoppingorders',
                    name: 'shoppingorders',
                    component: resolve => (require(["@/components/market/shoppingorders"], resolve)),
                },
                {
                    path: '/shoppsetmain',
                    name: 'shoppsetmain',
                    component: resolve => (require(["@/components/market/shoppsetmain"], resolve)),
                },
                {
                    path: '/shoppingcatlist',
                    name: 'shoppingcatlist',
                    component: resolve => (require(["@/components/market/shoppingcatlist"], resolve)),
                },
                {
                    path: '/shoppingbrand',
                    name: 'shoppingbrand',
                    component: resolve => (require(["@/components/market/shoppingbrand"], resolve)),
                },
                {
                    path: '/shoppinglable',
                    name: 'shoppinglable',
                    component: resolve => (require(["@/components/market/shoppinglable"], resolve)),
                },
                {
                    path: '/shoopingtemplate',
                    name: 'shoopingtemplate',
                    component: resolve => (require(["@/components/market/shoopingtemplate"], resolve)),
                },
                {
                    path: '/parameterset',
                    name: 'parameterset',
                    component: resolve => (require(["@/components/market/parameterset"], resolve)),
                }, {
                    path: '/distributionset',
                    name: 'distributionset',
                    component: resolve => (require(["@/components/market/distributionset"], resolve)),
                },
                {
                    path: '/addmodel',
                    name: 'addmodel',
                    component: resolve => (require(["@/components/market/addmodel"], resolve)),
                },
                {
                    path: '/orderdesc',
                    name: 'orderdesc',
                    component: resolve => (require(["@/components/market/orderdesc"], resolve)),
                },
                {
                    path: '/saleafter',
                    name: 'saleafter',
                    component: resolve => (require(["@/components/market/saleafter"], resolve)),
                },
                // 题库
                {
                    path: '/chaperindex',
                    name: 'chaperindex',
                    component: resolve => (require(["@/components/tiku/chapteradmin/chaperindex"], resolve)),
                },
                {
                    path: '/computerindex',
                    name: 'computerindex',
                    component: resolve => (require(["@/components/tiku/computer/computerindex"], resolve)),
                },
                {
                    path: '/addcomputer',
                    name: 'addcomputer',
                    component: resolve => (require(["@/components/tiku/computer/addcomputer"], resolve)),
                },
                {
                    path: '/computerpeople',
                    name: 'computerpeople',
                    component: resolve => (require(["@/components/tiku/computer/computerpeople"], resolve)),
                },
                {
                    path: '/testset',
                    name: 'testset',
                    component: resolve => (require(["@/components/tiku/chapteradmin/testset"], resolve)),
                },
                {
                    path: '/labelindex',
                    name: 'labelindex',
                    component: resolve => (require(["@/components/tiku/label/labelindex"], resolve)),
                },
                {
                    path: '/paperindex',
                    name: 'paperindex',
                    component: resolve => (require(["@/components/tiku/paperadmin/paperindex"], resolve)),
                },
                {
                    path: '/addtest',
                    name: 'addtest',
                    component: resolve => (require(["@/components/tiku/paperadmin/addtest"], resolve)),
                },
                {
                    path: '/textindex',
                    name: 'textindex',
                    component: resolve => (require(["@/components/tiku/textadmin/textindex"], resolve)),
                },
                {
                    path: '/addtext',
                    name: 'addtext',
                    component: resolve => (require(["@/components/tiku/textadmin/addtext"], resolve)),
                },
                {
                    path: '/edittext',
                    name: 'edittext',
                    component: resolve => (require(["@/components/tiku/textadmin/edittext"], resolve)),
                },
                {
                    path: '/addtextfirst',
                    name: 'addtextfirst',
                    component: resolve => (require(["@/components/tiku/assistant//addtest/addtextfirst"], resolve)),
                },
                {
                    path: '/textdetail',
                    name: 'textdetail',
                    component: resolve => (require(["@/components/tiku/textadmin/textdetail"], resolve)),
                },
                {
                    path: '/stulist',
                    name: 'stulist',
                    component: resolve => (require(["@/components/tiku/textadmin/stulist"], resolve)),
                },
                {
                    path: '/answersta',
                    name: 'answersta',
                    component: resolve => (require(["@/components/tiku/textadmin/answersta"], resolve)),
                },
                {
                    path: '/markpaper',
                    name: 'markpaper',
                    component: resolve => (require(["@/components/tiku/textadmin/markpaper"], resolve)),
                },
                {
                    path: '/markdec',
                    name: 'markdec',
                    component: resolve => (require(["@/components/tiku/textadmin/markdec"], resolve)),
                },
                {
                    path: '/everyindex',
                    name: 'everyindex',
                    component: resolve => (require(["@/components/tiku/everyday/everyindex"], resolve)),
                },
                {
                    path: '/Intelque',
                    name: 'Intelque',
                    component: resolve => (require(["@/components/tiku/Intelque/Intelque"], resolve)),
                },
                {
                    path: '/payorder',
                    name: 'payorder',
                    component: resolve => (require(["@/components/tiku/payorder/payorder"], resolve)),
                },
                {
                    path: '/leadshower',
                    name: 'leadshower',
                    component: resolve => (require(["@/components/tiku/assistant/leadshower"], resolve)),
                },
                {
                    path: '/kdlist',
                    name: 'kdlist',
                    component: resolve => (require(["@/components/tiku/kdadmin/kdlist"], resolve)),
                },
                {
                    path: '/addkd',
                    name: 'addkd',
                    component: resolve => (require(["@/components/tiku/kdadmin/addkd"], resolve)),
                },
                {
                    path: '/leadkd',
                    name: 'leadkd',
                    component: resolve => (require(["@/components/tiku/kdadmin/leadkd"], resolve)),
                },

                // 题库会员
                {
                    path: '/vipcenter',
                    name: 'vipcenter',
                    component: resolve => (require(["@/components/tiku/tikuvip/vipcenter"], resolve)),
                },
                {
                    path: '/addvipmodle',
                    name: 'addvipmodle',
                    component: resolve => (require(["@/components/tiku/tikuvip/addvipmodle"], resolve)),
                },


                // 科目类别管理
                {
                    path: '/subcateadmin',
                    name: 'subcateadmin',
                    component: resolve => (require(["@/components/tiku/subcate/subcateadmin"], resolve)),
                },
                // 试题直播课
                {
                    path: '/testdemand',
                    name: 'testdemand',
                    component: resolve => (require(["@/components/course/coursetk/testdemand"], resolve)),
                },
                // 高频错题
                {
                    path: '/frewrong',
                    name: 'frewrong',
                    component: resolve => (require(["@/components/tiku/heightwrong/frewrong"], resolve)),
                },
                {
                    path: '/newtestlist',
                    name: 'newtestlist',
                    component: resolve => (require(["@/components/tiku/newtest/newtestlist"], resolve)),
                },
                {
                    path: '/newaddtest',
                    name: 'newaddtest',
                    component: resolve => (require(["@/components/tiku/newtest/newaddtest"], resolve)),
                },

                // 题库活动
                {
                    path: '/tk_addassemble',
                    name: 'tk_addassemble',
                    component: resolve => (require(["@/components/tiku/activity/assemble/tk_addassemble"], resolve)),
                },
                {
                    path: '/tk_assemblelist',
                    name: 'tk_assemblelist',
                    component: resolve => (require(["@/components/tiku/activity/assemble/tk_assemblelist"], resolve)),
                },
                {
                    path: '/tk_assistorder',
                    name: 'tk_assistorder',
                    component: resolve => (require(["@/components/tiku/activity/assemble/tk_assistorder"], resolve)),
                },

                // 裂变活动
                {
                    path: '/fissionlist',
                    name: 'fissionlist',
                    component: resolve => (require(["@/components/activity/fissionwechat/fissionadmin/fissionlist"], resolve)),
                },
                {
                    path: '/fissionsta',
                    name: 'fissionsta',
                    component: resolve => (require(["@/components/activity/fissionwechat/fissionadmin/fissionsta"], resolve)),
                },
                {
                    path: '/addfission',
                    name: 'addfission',
                    component: resolve => (require(["@/components/activity/fissionwechat/fissionadmin/addfission"], resolve)),
                },
                {
                    path: '/fissionadmin',
                    name: 'fissionadmin',
                    component: resolve => (require(["@/components/activity/fissionwechat/fissionadmin/fissionadmin"], resolve)),
                },
                //app搭建
                {
                    path: '/makeapp',
                    name: 'makeapp',
                    component: resolve => (require(["@/components/app/makeapp"], resolve)),
                },
                {
                    path: '/freepeople',
                    name: 'freepeople',
                    component: resolve => (require(["@/components/questionbank/freepeople"], resolve)),
                },
                {
                    path: '/msgpush',
                    name: 'msgpush',
                    component: resolve => (require(["@/components/app/msgpush"], resolve)),
                },
                {
                    path: '/addappmsg',
                    name: 'addappmsg',
                    component: resolve => (require(["@/components/app/addappmsg"], resolve)),
                },
                //currency
                {
                    path: '/addcurrency',
                    name: 'addcurrency',
                    component: resolve => (require(["@/components/app/addcurrency"], resolve)),
                },


                // 获客宝
                {
                    path: '/getcustom',
                    name: 'getcustom',
                    component: resolve => (require(["@/components/getcustom/getcustom"], resolve)),
                },
                {
                    path: '/uploadposter',
                    name: 'uploadposter',
                    component: resolve => (require(["@/components/getcustom/uploadposter"], resolve)),
                },


            ]
        },
        {
            path: '/pushflow',
            name: 'pushflow',
            component: resolve => (require(["@/components/course/pushflow"], resolve)),
        },
        {
            path: '/pushlogin',
            name: 'pushlogin',
            component: resolve => (require(["@/components/course/pushlogin"], resolve)),
        },
        {
            path: '/clip',
            name: 'clip',
            component: resolve => (require(["@/components/course/clip/clip"], resolve)),
        },
        {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },






        // [帮助中心----CDY]
        {
            path: '/computers',
            name: 'computers',
            component: resolve => (require(["@/components/computer/computers"], resolve)),
            meta: {
                title: '店铺搭建',
            }
        },

        // [帮助中心----CDY]
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: resolve => (require(["@/components/page/aaHelp/helpCenter"], resolve)),
            meta: {
                title: '帮助中心',
            }
        },
        {
            path: '/shopstore',
            name: 'shopstore',
            component: resolve => (require(["@/components/shoppingpage/shopstore"], resolve)),
            meta: {
                title: '商城装修',
            }
        },
        {
            path: '/wechatlogin',
            name: 'wechatlogin',
            component: resolve => (require(["@/components/comment/wechatlogin"], resolve)),
            meta: {
                title: '河南睿玑',
            }
        },
        {
            path: '/makequestion',
            name: 'makequestion',
            component: resolve => (require(["@/components/questionbank/makequestion"], resolve)),
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        return {
            x: 0,
            y: 0
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js